import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataSource } from '../../models/dataSource';
import { PaginationState } from '../../models/pagination';
import { DataSourceTopbarTab } from '../../models/tabs';

type DataSourcesState = {
  items?: DataSource[];
  edit?: {
    dataSource?: Partial<DataSource>;
  };
  ui: {
    tabs: DataSourceTopbarTab[];
    pagination: PaginationState;
    searchText: string;
  };
};

export const initialState: DataSourcesState = {
  items: [],
  ui: {
    tabs: [
      { id: 'datasource.table', current: true },
      { id: 'datasource.catalog', current: false },
    ],
    pagination: {
      pageNo: 0,
      pageSize: 0,
    },
    searchText: '',
  },
};

const dataSourcesSlice = createSlice({
  name: 'dataSources',
  initialState,
  reducers: {
    stashDataSource: (state, action: PayloadAction<Partial<DataSource>>) => {
      return {
        ...state,
        edit: {
          ...state.edit,
          dataSource: { ...state.edit?.dataSource, ...action.payload },
        },
      };
    },
    clearStashedDataSource: (state) => ({
      ...state,
      edit: {
        ...state.edit,
        dataSource: undefined,
      },
    }),
    setDataSourceTabs: (state, action: PayloadAction<DataSourceTopbarTab[]>) => ({
      ...state,
      ui: {
        ...state.ui,
        tabs: action.payload,
      },
    }),
    setPagination: (state, action: PayloadAction<PaginationState>) => ({
      ...state,
      ui: {
        ...state.ui,
        pagination: action.payload,
      },
    }),
    setSearchText: (state, action: PayloadAction<string>) => ({
      ...state,
      ui: {
        ...state.ui,
        searchText: action.payload,
      },
    }),
  },
});

export const { stashDataSource, clearStashedDataSource, setDataSourceTabs, setPagination, setSearchText } = dataSourcesSlice.actions;

export default dataSourcesSlice.reducer;
